import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Notification from 'flarum/forum/components/Notification';
import NotificationListState from 'flarum/forum/states/NotificationListState';
function notificationHref(notification) {
  try {
    const Component = app.notificationComponents[notification.contentType()];
    if (!Component || typeof Component.prototype.href !== 'function') {
      return app.route('notifications');
    }
    return Component.prototype.href.call({
      attrs: {
        notification
      },
      props: {
        notification
      }
    }) || app.route('notifications');
  } catch (error) {
    console.warn('VAL: lien de notification introuvable', error);
    return app.route('notifications');
  }
}
function showNotificationToast(count, notification) {
  if (notification === void 0) {
    notification = null;
  }
  document.querySelector('.ValNotificationToast')?.remove();
  const toast = document.createElement('div');
  toast.className = 'ValNotificationToast';
  toast.setAttribute('role', 'status');
  const title = document.createElement('div');
  title.className = 'ValNotificationToast-title';
  title.textContent = count > 1 ? `${count} nouvelles notifications` : 'Nouvelle notification';
  toast.appendChild(title);
  if (notification) {
    const fromUser = notification.fromUser?.();
    if (fromUser) {
      const username = fromUser.username?.() || '';
      const displayName = fromUser.displayName?.() || username;
      const author = document.createElement('div');
      author.className = 'ValNotificationToast-author';
      author.textContent = displayName && username && displayName !== username ? `${displayName} (@${username})` : username ? `@${username}` : displayName;
      toast.appendChild(author);
    }
  }
  const actions = document.createElement('div');
  actions.className = 'ValNotificationToast-actions';
  const link = document.createElement('a');
  link.className = 'ValNotificationToast-link';
  link.textContent = 'Voir la notification';
  link.href = notification ? notificationHref(notification) : app.route('notifications');
  link.addEventListener('click', () => {
    if (notification && !notification.isRead?.()) {
      notification.save({
        isRead: true
      });
      const user = app.session?.user;
      if (user) {
        user.pushAttributes({
          unreadNotificationCount: Math.max(0, Number(user.unreadNotificationCount?.() || 0) - 1)
        });
      }
    }
    toast.remove();
  });
  actions.appendChild(link);
  toast.appendChild(actions);
  const close = document.createElement('button');
  close.className = 'ValNotificationToast-close';
  close.type = 'button';
  close.setAttribute('aria-label', 'Fermer');
  close.textContent = '×';
  close.addEventListener('click', () => {
    toast.remove();
  });
  toast.appendChild(close);
  document.body.appendChild(toast);
  requestAnimationFrame(() => {
    toast.classList.add('is-visible');
  });
}
app.initializers.add('val-ui-notification-enhancements', () => {
  /* VAL — compteur notifications après lecture */
  extend(Notification.prototype, 'markAsRead', () => {
    m.redraw();
  });
  extend(NotificationListState.prototype, 'markAllAsRead', () => {
    m.redraw();
  });
  extend(NotificationListState.prototype, 'deleteAll', () => {
    m.redraw();
  });
  app.beforeMount(() => {
    const user = app.session?.user;
    if (!user) return;
    let previousUnread = Number(user.unreadNotificationCount?.() || 0);
    let polling = false;
    const refreshNotifications = async () => {
      if (polling || document.hidden) return;
      polling = true;
      try {
        const refreshedUser = await app.store.find('users', user.id());
        const currentUnread = Number(refreshedUser?.unreadNotificationCount?.() ?? user.unreadNotificationCount?.() ?? 0);
        if (currentUnread > previousUnread) {
          const arrived = currentUnread - previousUnread;
          let latestNotification = null;
          try {
            const notifications = await app.store.find('notifications', {
              page: {
                limit: Math.max(1, arrived)
              }
            });
            if (Array.isArray(notifications) && notifications.length) {
              latestNotification = notifications[0];
            }
          } catch (error) {
            console.warn('VAL: chargement de la notification impossible', error);
          }
          showNotificationToast(arrived, latestNotification);
        }
        previousUnread = currentUnread;
        m.redraw();
      } catch (error) {
        console.warn('VAL: rafraîchissement des notifications impossible', error);
      } finally {
        polling = false;
      }
    };
    window.setInterval(refreshNotifications, 30000);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        refreshNotifications();
      }
    });
  });
});